<template>
    <span>
        <v-menu v-model="menu" :offset-x="compact" :offset-y="!compact" :right="compact" :nudge-top="compact ? 16 : 0" :disabled="isDisabled" min-width="240">
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="compact" text small class="px-2" min-width="0" v-bind="attrs" v-on="on" @click.stop.prevent>
                    <v-icon small>mdi-plus</v-icon>
                </v-btn>
                <v-btn v-else color="primary" :disabled="isDisabled" v-bind="attrs" v-on="on" class="mr-2">
                    <v-icon left>mdi-plus</v-icon>
                    Snapshot
                    <v-icon right>mdi-chevron-down</v-icon>
                </v-btn>
            </template>
            <v-list nav dense>
                <v-list-item @click="takeQuickSnapshot">
                    <v-list-item-icon>
                        <v-icon>mdi-camera-plus-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Quick snapshot</v-list-item-title>
                </v-list-item>
                <v-list-item @click="takeDetailedSnapshot">
                    <v-list-item-icon>
                        <v-icon>mdi-camera-plus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Snapshot and describe</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <v-dialog v-model="detailedDialog" max-width="600" persistent>
            <v-card flat>
                <v-card-title class="flex-nowrap align-start">
                    <div class="d-flex align-center secondary--text">
                        <span>Add New Snapshot</span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="snapshotCreationLoading" icon @click="closeDetailedDialog">
                        <v-icon>clear</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pt-4">
                    <v-form ref="detailedForm" v-model="valid" @submit.prevent="addNewSnapshot">
                        <v-text-field
                            :disabled="snapshotCreationLoading"
                            label="Provide a snapshot name here"
                            v-model="snapshotName"
                            :rules="[rules.nonEmpty]"
                            required
                            outlined></v-text-field>
                        <v-textarea
                            v-model="snapshotDescription"
                            label="Provide a description of your snapshot"
                            rows="4"
                            auto-grow
                            :rules="[rules.nonEmpty]"
                            required
                            :disabled="snapshotCreationLoading"
                            outlined></v-textarea>
                    </v-form>
                    <v-alert v-if="snapshotCreationError" color="error" icon="warning" text class="mt-2">
                        <div class="d-flex flex-column">
                            <span class="font-weight-bold">Snapshot creation error</span>
                            {{ snapshotCreationErrorContent }}
                        </div>
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" :loading="snapshotCreationLoading" :disabled="!valid || snapshotCreationLoading" @click="addNewSnapshot">
                        add snapshot
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
import { enumsData } from '@/mixins/enums'
import { snapshotEnums } from '@/mixins/snapshot'
import { createQuickAndDetailedSnapshots } from '@/mixins/createSnapshot'
import { mapGetters } from 'vuex'
import { makeShortId } from '@/utils'

export default {
    name: 'SnapshotCreateButton',
    mixins: [enumsData, snapshotEnums, createQuickAndDetailedSnapshots],
    props: {
        compact: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            menu: false,
            detailedDialog: false,
            snapshotName: '',
            snapshotDescription: '',
            valid: false,
            rules: {
                nonEmpty: p => p.length > 0 || 'Please provide a value.'
            }
        }
    },
    computed: {
        ...mapGetters('spaceStore', ['isSpaceArchived', 'isSpaceInAnyRestState']),
        isDisabled() {
            return this.isSpaceArchived || this.isSpaceInAnyRestState
        }
    },
    watch: {
        snapshotCreationLoading(val) {
            if (!val && this.detailedDialog && !this.snapshotCreationError) {
                this.closeDetailedDialog()
            }
        }
    },
    methods: {
        takeQuickSnapshot() {
            this.menu = false
            this.addSnapshot(this.snapshotTypes.QUICK_SNAPSHOT)
        },
        takeDetailedSnapshot() {
            this.menu = false
            this.detailedDialog = true
        },
        closeDetailedDialog() {
            this.detailedDialog = false
            this.snapshotName = ''
            this.snapshotDescription = ''
            this.snapshotCreationError = false
            this.$nextTick(() => {
                if (this.$refs.detailedForm) this.$refs.detailedForm.resetValidation()
            })
        },
        addNewSnapshot() {
            if (!this.valid) return
            this.addSnapshot(this.snapshotTypes.DETAILED_SNAPSHOT, this.snapshotName, makeShortId(this.snapshotName), this.snapshotDescription)
        }
    }
}
</script>
